import { Request } from '@/classes/Request'
import type { AthleticsConversation, AthleticsMessageAuthor } from '@/types/enrollments'

const intOrNull = (value: any): number | null =>
  value === undefined || value === null || value === '' ? null : Number(value)

export const normalizeAthleticsAuthor = (raw: any): AthleticsMessageAuthor => ({
  type: raw?.type === 'coach' ? 'coach' : 'family_user',
  name: String(raw?.name ?? ''),
  isMine: raw?.is_mine === true
})

export const normalizeAthleticsConversation = (raw: any): AthleticsConversation => {
  const studentAccountId = intOrNull(raw?.student?.student_account_id ?? raw?.student_account_id)
  return {
    id: String(raw?.id ?? ''),
    kind: raw?.kind === 'announcement' ? 'announcement' : 'student',
    programSubgroupId: Number(raw?.program_subgroup_id ?? 0),
    teamName: raw?.team?.name ?? null,
    studentAccountId,
    enrollmentId: intOrNull(raw?.enrollment_id),
    studentAccountIds: Array.isArray(raw?.student_account_ids)
      ? raw.student_account_ids.map(Number)
      : studentAccountId !== null
        ? [studentAccountId]
        : [],
    subject: raw?.subject ?? null,
    audience: raw?.audience ?? null,
    lastMessageAt: raw?.last_message_at ?? null,
    lastMessagePreview: String(raw?.last_message_preview ?? ''),
    unreadCount: Number(raw?.unread_count ?? 0),
    canReply: raw?.can_reply ?? raw?.kind !== 'announcement',
    createdBy: raw?.created_by
      ? {
          type: raw.created_by.type === 'coach' ? 'coach' : 'family_user',
          name: String(raw.created_by.name ?? '')
        }
      : null,
    createdAt: raw?.created_at ?? null
  }
}

// GET /ajax/athletics/messages/inbox (DTA-799 round 11): this family's team
// announcements (teams of their students) and their own student threads,
// newest first, with this family user's unread counts. A 403 is a business
// refusal, not a dead session.
export const athleticsMessagesInbox = async (): Promise<AthleticsConversation[]> => {
  const response = await new Request(undefined, 'json', { redirectOnForbidden: false }).get(
    '/ajax/athletics/messages/inbox'
  )
  return (response.data?.conversations ?? []).map(normalizeAthleticsConversation)
}
